export default __webpack_public_path__ + "pgnv-assets/0992f7dc96471b13f65b19fd70c5d378.png";